(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["boun-combo-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    var TIERS = [
      { min: 1, off: 0,    label: 'Sin dto.' },
      { min: 2, off: 0.10, label: '10% OFF' },
      { min: 3, off: 0.15, label: '15% OFF' },
      { min: 4, off: 0.20, label: '20% OFF' },
      { min: 5, off: 0.25, label: '25% OFF' }
    ];
    var DISCOUNT_CODES = { 2: 'BOUNCOMBO10', 3: 'BOUNCOMBO15', 4: 'BOUNCOMBO20', 5: 'BOUNCOMBO25' };

    function fmt(cents) {
      try {
        return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(Math.round(cents / 100));
      } catch (e) {
        return '$ ' + Math.round(cents / 100).toLocaleString('es-CO');
      }
    }
    function tierFor(qty) {
      var t = TIERS[0];
      for (var i = 0; i < TIERS.length; i++) { if (qty >= TIERS[i].min) t = TIERS[i]; }
      return t;
    }

    /* v83c — Refresh cart-drawer-component's containing section via Shopify
       Section Rendering API so newly added items show up. Without this the
       drawer renders with stale "empty cart" markup (since raw /cart/add.js
       doesn't trigger Horizon's auto-refresh). */
    function refreshCartDrawerSection() {
      return new Promise(function (resolve) {
        try {
          var cmp = document.querySelector('cart-drawer-component');
          if (!cmp) return resolve(false);
          var section = cmp.closest('[id^="shopify-section-"]');
          if (!section) return resolve(false);
          var sid = section.id.replace('shopify-section-', '');
          fetch('/?sections=' + encodeURIComponent(sid), {
            headers: { 'Accept': 'application/json' },
            credentials: 'same-origin'
          }).then(function (r) { return r.ok ? r.json() : null; }).then(function (data) {
            if (!data || !data[sid]) return resolve(false);
            var temp = document.createElement('div');
            temp.innerHTML = data[sid];
            var newCart = temp.querySelector('cart-drawer-component');
            var curCart = document.querySelector('cart-drawer-component');
            if (newCart && curCart) {
              curCart.innerHTML = newCart.innerHTML;
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              return resolve(true);
            }
            resolve(false);
          }).catch(function () { resolve(false); });
        } catch (e) { resolve(false); }
      });
    }

    function openTheDrawer() {
      /* v110 — Always force MODAL state on the fresh dialog. After
         refreshCartDrawerSection() swaps innerHTML, the new dialog may
         arrive with `open` attribute already set (from the server-side
         template) BUT not actually in modal state. Without modal mode,
         the backdrop never paints and the dialog renders as a normal
         block. Force-close any non-modal state then call showModal so
         we always end up in true modal state with backdrop. */
      var dialog = document.querySelector('cart-drawer-component dialog, dialog.cart-drawer__dialog');
      if (dialog) {
        /* If dialog is NOT in modal state (matches(':modal') returns
           false), close it first so showModal can be called cleanly. */
        var isModal = false;
        try { isModal = dialog.matches(':modal'); } catch (e) {}
        if (!isModal) {
          if (dialog.hasAttribute('open')) {
            try { dialog.close(); } catch (e) {}
          }
          try { dialog.showModal(); return true; } catch (e) {}
        } else {
          /* Already in modal state — just ensure styles apply */
          return true;
        }
        /* Final fallbacks if showModal threw */
        try { dialog.show(); return true; } catch (e) {}
        dialog.setAttribute('open', '');
        return true;
      }
      /* Fallbacks if no dialog found yet */
      var cmp = document.querySelector('cart-drawer-component');
      if (cmp) {
        if (typeof cmp.open === 'function')      { try { cmp.open();      return true; } catch (e) {} }
        if (typeof cmp.show === 'function')      { try { cmp.show();      return true; } catch (e) {} }
      }
      var trigger = document.querySelector('button[aria-label*="Carrito" i], [data-testid="cart-drawer-trigger"], a[href$="/cart"]');
      if (trigger && typeof trigger.click === 'function') { trigger.click(); return true; }
      return false;
    }

    function init(root) {
      if (!root || root.__bounBuilderInit) return;
      root.__bounBuilderInit = true;

      var cards       = root.querySelectorAll('[data-product]');
      var totalEl     = root.querySelector('[data-total]');
      var strikeEl    = root.querySelector('[data-subtotal-strike]');
      var badgeEl     = root.querySelector('[data-discount-badge]');
      var countEl     = root.querySelector('[data-summary-count]');
      var msgEl       = root.querySelector('[data-summary-msg]');
      var tierMsg     = root.querySelector('[data-tier-msg]');
      var tierFill    = root.querySelector('[data-tier-fill]');
      var tierEls     = root.querySelectorAll('[data-tier]');
      var summary     = root.querySelector('[data-summary]');
      var checkoutBtn = root.querySelector('[data-checkout]');
      var ctaLabel    = root.querySelector('[data-cta-label]');
      var itemsList   = root.querySelector('[data-summary-list]');
      var toggleBtn   = root.querySelector('[data-summary-toggle]');
      var toggleLabel = root.querySelector('[data-toggle-label]');

      function renderItems(entries) {
        if (!itemsList) return;
        var existing = {};
        Array.prototype.forEach.call(itemsList.querySelectorAll('[data-item-line]'), function (el) {
          existing[el.getAttribute('data-item-line')] = el;
        });
        var seen = {};
        entries.forEach(function (e) {
          seen[e.line] = true;
          var node = existing[e.line] ;
          if (node) {
            var qtyEl = node.querySelector('.boun-bundle__item-qty');
            if (qtyEl) qtyEl.textContent = '×' + e.qty;
            var priceEl = node.querySelector('.boun-bundle__item-price');
            if (priceEl) priceEl.textContent = fmt(e.qty * e.price);
          } else {
            var item = document.createElement('div');
            item.className = 'boun-bundle__item';
            item.setAttribute('data-item-line', e.line);
            item.style.setProperty('--c', e.color);
            item.innerHTML =
              '<div class="boun-bundle__item-media">' +
                '<img src="' + e.img + '" alt="BOUN ' + e.name + '" loading="lazy">' +
                '<span class="boun-bundle__item-qty">×' + e.qty + '</span>' +
                '<button type="button" class="boun-bundle__item-remove" data-remove="' + e.line + '" aria-label="Quitar ' + e.name + ' del combo">' +
                  '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
                '</button>' +
              '</div>' +
              '<div class="boun-bundle__item-meta">' +
                '<span class="boun-bundle__item-name">' + e.name + '</span>' +
                '<span class="boun-bundle__item-db">' + e.db + '</span>' +
                '<span class="boun-bundle__item-price">' + fmt(e.qty * e.price) + '</span>' +
              '</div>';
            itemsList.appendChild(item);
          }
        });
        Object.keys(existing).forEach(function (line) {
          if (!seen[line]) {
            var n = existing[line];
            n.classList.add('boun-bundle__item--removing');
            setTimeout(function () { if (n && n.parentNode) n.parentNode.removeChild(n); }, 240);
          }
        });
      }

      function update() {
        var totalQty = 0, subtotal = 0, entries = [];
        cards.forEach(function (card) {
          var qty = parseInt(card.querySelector('[data-qty]').value, 10) || 0;
          var price = parseInt(card.getAttribute('data-price'), 10) || 0;
          totalQty += qty;
          subtotal += qty * price;
          if (qty > 0) {
            card.classList.add('has-qty');
            entries.push({
              line: card.getAttribute('data-line'),
              name: card.getAttribute('data-name'),
              db: card.getAttribute('data-db'),
              img: card.getAttribute('data-img'),
              color: card.style.getPropertyValue('--c').trim() || '#8B7BD8',
              qty: qty, price: price
            });
          } else {
            card.classList.remove('has-qty');
          }
          var minus = card.querySelector('[data-qty-step="-1"]');
          if (minus) minus.disabled = qty <= 0;
        });

        var tier = tierFor(totalQty);
        var discount = Math.round(subtotal * tier.off);
        var total = subtotal - discount;
        var hasDiscount = discount > 0;

        if (totalEl) totalEl.textContent = fmt(total);
        if (strikeEl) {
          if (hasDiscount) { strikeEl.hidden = false; strikeEl.textContent = fmt(subtotal); }
          else strikeEl.hidden = true;
        }
        if (badgeEl) {
          if (hasDiscount) { badgeEl.hidden = false; badgeEl.textContent = '-' + Math.round(tier.off * 100) + '%'; }
          else badgeEl.hidden = true;
        }
        if (countEl) countEl.textContent = totalQty;

        if (summary) {
          summary.classList.toggle('has-discount', hasDiscount);
          summary.classList.toggle('has-items', totalQty > 0);
          summary.classList.toggle('is-empty', totalQty === 0);
          summary.classList.add('is-visible');
        }

        tierEls.forEach(function (el) {
          var min = parseInt(el.getAttribute('data-min'), 10);
          el.classList.remove('is-active', 'is-reached');
          if (totalQty >= min) el.classList.add('is-reached');
          if (totalQty === min || (min === 5 && totalQty >= 5)) el.classList.add('is-active');
        });
        if (tierFill) tierFill.style.width = Math.min(100, (totalQty / 5) * 100) + '%';

        if (tierMsg) {
          if (totalQty === 0) tierMsg.innerHTML = 'Agrega productos para armar tu combo.';
          else if (totalQty >= 5) tierMsg.innerHTML = '¡Máximo descuento desbloqueado! <strong>25% OFF</strong> aplicado.';
          else {
            var next = TIERS.find(function (t) { return t.min > totalQty; });
            if (next) {
              var diff = next.min - totalQty;
              tierMsg.innerHTML = 'Suma ' + diff + ' ' + (diff === 1 ? 'producto' : 'productos') + ' más para desbloquear <strong>' + next.label + '</strong>.';
            }
          }
        }
        if (msgEl) {
          if (totalQty === 0) msgEl.textContent = 'Agrega 2 productos para empezar a ahorrar.';
          else if (totalQty === 1) msgEl.innerHTML = 'Suma <strong>1 más</strong> y empiezas a ahorrar 10%.';
          else if (totalQty >= 5) msgEl.innerHTML = '¡Máximo descuento desbloqueado! Ahorras ' + fmt(discount) + '.';
          else msgEl.innerHTML = 'Estás ahorrando <strong>' + tier.label + '</strong> · ' + fmt(discount) + ' menos.';
        }
        if (checkoutBtn) {
          checkoutBtn.disabled = totalQty < 1;
          if (ctaLabel) {
            if (totalQty < 1) ctaLabel.textContent = 'Añade productos al combo';
            else ctaLabel.textContent = 'Añade tu combo al carrito · ' + fmt(total);
          }
        }
        renderItems(entries);
      }

      cards.forEach(function (card) {
        var input = card.querySelector('[data-qty]');
        var minus = card.querySelector('[data-qty-step="-1"]');
        var plus  = card.querySelector('[data-qty-step="1"]');
        if (minus) minus.addEventListener('click', function () {
          var v = (parseInt(input.value, 10) || 0) - 1;
          if (v < 0) v = 0;
          input.value = v;
          update();
        });
        if (plus) plus.addEventListener('click', function () {
          var v = (parseInt(input.value, 10) || 0) + 1;
          var max = parseInt(input.getAttribute('max'), 10) || 20;
          if (v > max) v = max;
          input.value = v;
          update();
        });
        if (input) input.addEventListener('input', function () {
          var v = parseInt(input.value, 10);
          if (isNaN(v) || v < 0) v = 0;
          if (v > 20) v = 20;
          input.value = v;
          update();
        });
        var media = card.querySelector('.boun-builder__media');
        if (media) media.addEventListener('click', function () { if (plus) plus.click(); });
      });

      if (itemsList) {
        itemsList.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-remove]');
          if (!btn) return;
          var line = btn.getAttribute('data-remove');
          var card = root.querySelector('[data-line="' + line + '"]');
          if (!card) return;
          var input = card.querySelector('[data-qty]');
          if (!input) return;
          input.value = 0;
          update();
        });
      }

      function setCollapsed(collapsed) {
        if (!summary) return;
        summary.classList.toggle('is-collapsed', collapsed);
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        if (toggleLabel) toggleLabel.textContent = collapsed ? 'Expandir' : 'Contraer';
        try { localStorage.setItem('boun-combo-collapsed', collapsed ? '1' : '0'); } catch (e) {}
      }
      if (toggleBtn) toggleBtn.addEventListener('click', function () {
        setCollapsed(!summary.classList.contains('is-collapsed'));
      });
      try { if (localStorage.getItem('boun-combo-collapsed') === '1') setCollapsed(true); } catch (e) {}

      if (checkoutBtn) checkoutBtn.addEventListener('click', function () {
        if (checkoutBtn.disabled) return;
        var items = [], totalQty = 0;
        cards.forEach(function (card) {
          var qty = parseInt(card.querySelector('[data-qty]').value, 10) || 0;
          var vid = card.getAttribute('data-variant-id');
          if (qty > 0 && vid) {
            items.push({ id: parseInt(vid, 10), quantity: qty, properties: { '_combo': 'arma-tu-combo' } });
            totalQty += qty;
          }
        });
        if (!items.length) return;
        var orig = ctaLabel ? ctaLabel.textContent : '';
        checkoutBtn.classList.add('is-loading');
        checkoutBtn.disabled = true;
        if (ctaLabel) ctaLabel.textContent = 'Agregando combo…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function () {
            var code = DISCOUNT_CODES[Math.min(totalQty, 5)];
            /* v83c — Apply discount silently (cookie) → refresh cart-drawer
               section so the newly added items are in the DOM → then open. */
            var doRefreshAndOpen = function () {
              return refreshCartDrawerSection().then(function () {
                checkoutBtn.classList.remove('is-loading');
                checkoutBtn.disabled = false;
                if (ctaLabel) ctaLabel.textContent = orig;
                /* v83d — Open the drawer immediately and on multiple retries
                   to defeat any race with Horizon's custom element lifecycle. */
                openTheDrawer();
                setTimeout(openTheDrawer, 50);
                setTimeout(openTheDrawer, 200);
                setTimeout(openTheDrawer, 500);
                /* v110 — Removed the 1200ms redirect fallback to
                   /?open_drawer=1. The redirect caused the page to
                   navigate, which visually closes the drawer the user
                   just saw open. With the v110 force-modal logic in
                   openTheDrawer, the dialog reliably stays open after
                   the section refresh — no redirect needed. */
              });
            };
            if (code) {
              fetch('/discount/' + code, { credentials: 'same-origin' }).then(doRefreshAndOpen, doRefreshAndOpen);
            } else {
              doRefreshAndOpen();
            }
          })
          .catch(function () {
            checkoutBtn.classList.remove('is-loading');
            checkoutBtn.disabled = false;
            if (ctaLabel) ctaLabel.textContent = 'Error · Reintentar';
            setTimeout(function () { if (ctaLabel) ctaLabel.textContent = orig; }, 2400);
          });
      });

      try {
        var stage = JSON.parse(localStorage.getItem('boun-combo-stage') || '[]');
        if (stage && stage.length) {
          var addedNames = [];
          cards.forEach(function (card) {
            var vid = card.getAttribute('data-variant-id');
            if (vid && stage.indexOf(vid) !== -1) {
              var inp = card.querySelector('[data-qty]');
              if (inp) {
                inp.value = (parseInt(inp.value, 10) || 0) + 1;
                card.classList.add('boun-builder__card--just-added');
                addedNames.push(card.getAttribute('data-name') || '');
              }
            }
          });
          localStorage.removeItem('boun-combo-stage');
          setTimeout(function () { cards.forEach(function (c) { c.classList.remove('boun-builder__card--just-added'); }); }, 1800);
          if (addedNames.length) {
            setTimeout(function () {
              var first = root.querySelector('.boun-builder__card--just-added');
              if (first && first.scrollIntoView) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 200);
          }
        }
      } catch (err) {}

      update();
    }

    function initAll() { document.querySelectorAll('[data-combo-builder]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
